import { Text, Tooltip } from "@aurem/ui";
import { GitBranch } from "lucide-react";
import { useI18n } from "providers/I18nProvider";

export const WorkflowRunVersionCell = ({
  configVersion,
  dbVersion,
  isConfigRun,
}: {
  configVersion: number | null | undefined;
  dbVersion: number | null | undefined;
  isConfigRun: boolean;
}) => {
  const { t } = useI18n();

  if (!isConfigRun) {
    return dbVersion === null || dbVersion === undefined
      ? "-"
      : `v${String(dbVersion)}`;
  }

  const label =
    configVersion === null || configVersion === undefined
      ? "-"
      : `v${String(configVersion)}`;

  return (
    <Tooltip
      content={
        <Text size="xs">
          {t("apps.admin.internalResources.workflowRun.sources.config")}
        </Text>
      }
    >
      <div className="inline-flex items-center gap-1 cursor-pointer">
        <GitBranch size={14} className="text-neutral-500" />
        {label}
      </div>
    </Tooltip>
  );
};
